export const SET_GUEST = 'GUEST/SET_GUEST'
export const SET_GUESTS = 'GUEST/SET_GUESTS'
